// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"744dc1e5","453":"3f354d2f"}[chunkId] + ".chunk.js";
};